export enum FetchingState {
  Idle = 'idle',
  Loading = 'loading',
  Updating = 'updating',
  Succeeded = 'succeeded',
  Failed = 'failed'
}

export const RemindToFieldList = ['additional_agreement', 'promo_email_agreement'];
